import 'regenerator-runtime/runtime';
import 'core-js/stable';
import { render } from 'preact';
import App from './components/App';

render(<App />, document.getElementById('root'));
